import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ReportsService } from '../../../../services/reports.service';
import { NotificationService } from '../../../../services/notification.service';
import { RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-inspector-cai-report',
    imports: [TableModule, CommonModule, RouterModule, FormsModule, CommonModule],
    templateUrl: './inspector-cai-report.component.html',
    styleUrl: './inspector-cai-report.component.scss'
})
export class InspectorCaiReportComponent {
  newUserId: string = '';
  userVerified: boolean = false;
  userDoesNotExist: boolean = false;
  inspectorCaiReport: any;
  inspectorCaiReportData: any;
  facilityID: string = 'ES';
  showTable: boolean = false;
  userCai = '';
  isLoading: boolean = false;
  noDataFound: boolean = false;

  constructor(private report: ReportsService, private notificationService: NotificationService) { }

  ngOnInit() { }
  searchTag() {
    throw new Error('Method not implemented.');
  }

  runReport() { }

  verifyUser(): void {
    if (this.newUserId) {
      this.report.validateInspectorCaiReport(this.newUserId).subscribe(
        (data: any) => {
          this.inspectorCaiReport = data.userDetails;
          this.userCai = data.userDetails.cai;
          this.userVerified = true;
          this.notificationService.showSuccess(data.message);
        },
        (error: any) => {
          this.userDoesNotExist = true;
          this.userVerified = false;
          console.error('Error fetching air compliance details', error);
          this.notificationService.showError("Please enter a User email");
        }
      );
    }
  }

  getInspectorCaiReport() {
    this.isLoading = true;
    this.noDataFound = false;
    this.report
      .getInspectorCaiReport(this.facilityID, this.userCai, this.userCai)
      .subscribe(
        (data: any) => {

          this.inspectorCaiReportData = data.map((d: any) => {
            d.Permanent_Repair_Date = new Date(d.Permanent_Repair_Date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });

            if (d.Permanent_Repair_Date)
              d.Permanent_Repair_Date_Color = new Date(d.Permanent_Repair_Date) < new Date() ? 'red' : 'green';
            return d;
          }) || [];
          this.isLoading = false;
          this.showTable = true;
          this.noDataFound = !this.inspectorCaiReportData.length;
        },
        (error: any) => {
          this.isLoading = false;
          this.showTable = true;
          this.inspectorCaiReportData = [];
          this.noDataFound = true;
          console.error('Error fetching air compliance details', error);
        }
      );
  }

  return() {
    this.showTable = false;
    this.noDataFound = false;
  }

  clearUserID() {
    this.newUserId = '';
    this.userVerified = false;
    this.userDoesNotExist = false;
    this.noDataFound = false;
  }
  exportToExcel() {
    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.userCai,
      cai: this.userCai,
    };
    this.report.getInspectorCaiReportExcel(params).subscribe({
      next: (fileData: any) => {
        if (fileData) {
          saveAs(fileData, 'Inspector Cai Report.xlsx');
        }
      },
      error: (err: any) => {
        console.error('Error fetching report details:', err);
      },
    });
  }
}
